/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ClientType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type ClientType = typeof ClientType[keyof typeof ClientType];



